import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { AuthLayout } from "../../layouts/Auth";
import { ArrowLeft } from "lucide-react";
import { Mail } from "lucide-react";
import { Button } from "~/atoms/button";

export const EmailSent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const resend = () => {
    void navigate("/forgot-password");
  };

  return (
    <AuthLayout
      icon={
        <div className="bg-success/10 text-success flex size-11 items-center justify-center rounded-full">
          <Mail />
        </div>
      }
      title={t(($) => $.password.email.check)}
      description={t(($) => $.password.email.description)}
    >
      <div className="flex flex-col gap-2">
        <div className="text-muted-foreground flex items-center gap-2 text-base leading-6">
          {t(($) => $.password.email.receive)}
          <br />
          <p
            onClick={resend}
            className="text-primary cursor-pointer text-sm font-medium"
          >
            {t(($) => $.password.email.resend)}
          </p>
        </div>

        <Button
          className="max-w-fit"
          variant="default"
          onClick={() => navigate("/login")}
        >
          <ArrowLeft className="size-5" />
          {t(($) => $.password.backToLogin)}
        </Button>
      </div>
    </AuthLayout>
  );
};
